<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label>Tenant</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="tenantFilter"
          :options="tenantOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:tenantFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("unit.title", 2) }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="unitFilter"
          :options="unitOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:unitFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">
          {{ $tc('region.title', 2) }}
        </label>
        <v-select
          data-cy="automatest-v-select-region"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="regionOptions"
          class="w-100"
          multiple
          append-to-body
          :calculate-position="withPopper"
          :reduce="(val) => val.value"
          :value="customQueryParams.region"
          @input="updateCustomQueryParams('region', $event)"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">
          {{ $tc('municipality.title', 2) }}
        </label>
        <v-select
          data-cy="automatest-v-select-municipality"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="municipalityOptions"
          class="w-100"
          multiple
          append-to-body
          :calculate-position="withPopper"
          :reduce="(val) => val.value"
          :value="customQueryParams.municipality"
          @input="updateCustomQueryParams('municipality', $event)"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">Perfil de alarma</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="alarmProfileFilter"
          :options="alarmProfileOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:alarmProfileFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>       
      <BaseDateTime
        id="audit_start_at"
        :cols="6"
        :label="$t('hanwha_dvr.auditStartAt')"
        :value="customQueryParams.audit_start_at"
        :enable-time="false"
        date-format="Y-m-d"
        @input="updateCustomQueryParams('audit_start_at', $event)"
      />
      <BaseDateTime
        id="created_at"
        :cols="6"
        :label="$t('date.created_at')"
        :value="customQueryParams.created_at"
        :enable-time="false"
        date-format="Y-m-d"
        mode="range"
        @input="updateCustomQueryParams('created_at', $event)"
      />
      <BaseDateTime
        id="updated_at"
        :cols="6"
        :label="$t('date.updated_at')"
        :value="customQueryParams.updated_at"
        :enable-time="false"
        date-format="Y-m-d"
        mode="range"
        @input="updateCustomQueryParams('updated_at', $event)"
      />
      <BaseSelect
        id="enabled_recording_audit"
        :cols="6"
        :label="$t('hanwha_dvr.enabled_recording_audit')"
        :value="customQueryParams.enabled_recording_audit"
        @input="updateCustomQueryParams('enabled_recording_audit', $event)"
        :options="[{ value: '1', label: 'Sí' }, { value: '0', label: 'No' }]"
        :reduce="(item) => item.value"
      />
    </b-row>
  </div>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BRow, BCol, BButton } from "bootstrap-vue";
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";
import { BaseInput, BaseSelect, BaseDateTime } from "@/components/Form";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    vSelect,
    BaseInput,
    BaseSelect,
    BaseDateTime,
  },
  props: {
    tenantOptions: {
      type: Array,
      default: null,
    },
    tenantFilter: {
      type: Array,
      default: null,
    },
    unitOptions: {
      type: Array,
      default: () => [],
    },
    unitFilter: {
      type: Array,
      default: null,
    },
    alarmProfileOptions: {
      type: Array,
      default: () => [],
    },
    alarmProfileFilter: {
      type: Array,
      default: null,
    },
    customQueryParams: {
      type: Object,
      default: () => {},
    },
    regionOptions: {
      type: Array,
      default: () => [],
    },
    municipalityOptions: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const updateCustomQueryParams = (key, value) => {
      const data = {
        ...props.customQueryParams,
        [key]: value
      }
    
      emit('update:customQueryParams', data)
    }

    return {
      withPopper: popperHelper.withPopper,
      updateCustomQueryParams
    };
  },
};
</script>
